import React, { useState } from "react";
import '../../components/styles/FABCompany.css'; // CSS 파일 임포트

const FABCompnay: React.FC = () => {
    const [expandedIndices, setExpandedIndices] = useState<number[]>([]); // 클릭 시 정보 표시 여부 상태 추가

    const handleToggle = (index: number) => {
        setExpandedIndices(prev =>
            prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
        ); // 상태 반전
    };

    return (
        <div className="layout">
            <nav className="sidebar">
                <div>
                    | 거래중인 식당입니다.
                </div>
                <div className="search-box">
                    <div className="search-input">
                        <span className="search-icon">🔍</span>
                        <input type="text" placeholder="식당 검색" />
                    </div>
                    <button className="search-button">찾기</button>
                </div>
                <ul>
                    <li className="card">ㄹㄹ</li>
                    <li className="card">ㅈㅈ</li>
                    <li className="card">ㅎㅎ</li>
                </ul>
            </nav>

            <div className="main-content">
                <div>
                    | 식당이름01과 거래중인 내역입니다.
                    <button className="button">거래서 PDF 다운로드</button>
                </div>

                {/* 거래중인 긴 막대 추가 */}
                {["거래중 24.09.30 ~ 24.10.30", "거래중 24.10.01 ~ 24.11.01", "거래중 24.11.02 ~ 24.12.02", "거래중 24.12.03 ~ 24.01.03"].map((transaction, index) => (
                     <div key={index} className="transaction-wrapper">
                        <div className="long-box" onClick={() => handleToggle(index)}>
                            <span className="transaction-info">{transaction}</span>
                            <span className="arrow">
                                {expandedIndices.includes(index) ? '↑' : '↓'}
                            </span>
                        </div>
                        {/* 확장된 정보 표시 */}
                        {expandedIndices.includes(index) && (
                            <div className="info-list">
                                <ul>
                                    <li>대표연락처</li>
                                    <div className="divider" />
                                    <li>선불여부</li>
                                    <div className="divider" />
                                    <li>선불금액</li>
                                    <div className="divider" />
                                    <li>직원 사용 상한 금액</li>
                                    <div className="divider" />
                                    <li>매니저 사용 상한 금액</li>
                                    <div className="divider" />
                                    <li>메뉴</li>
                                </ul>
                                <div className="buttons">
                                    <button className="list-button">명단관리</button>
                                    <button className="list-button">상세 내역</button>
                                </div>
                                <div className="cancel-transaction">거래 취소</div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FABCompnay;
